import React, { Component } from 'react';
import './index.scss';
import dayjs from 'dayjs';
import axios from 'axios';
import { apiHost } from '../utils/Shared/constant';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = { update: '' };
    this._isMounted = false;
  }
  componentDidMount() {
    this._isMounted = true;

    axios.get(`${apiHost}/api/Setting/GetWebUpdateDatetime`)
    .then(res => {
       if (this._isMounted) {
      this.setState({ update: res.data.update })
       }
    })
  }
  componentWillUnmount() {
  this._isMounted = false; 
}
  render() {
    const { update } = this.state;
    return (
      <footer className="footer-block">
        <div className="container">
          <p class="copy-right" style={{fontWeight: "400"}}>本網站之授權，並不授予使用者代表本機關建議、認可或贊同其加值衍生物之地位，下載後加值之數據資料不屬本站權責範圍，須由使用者自行負責。</p>
          <p class="copy-right">© National Science and Technology Center for Disaster Reduction</p>
          {
            update &&
            <p className="update">最後更新時間：{ dayjs(update).format('YYYY-MM-DD') }</p>
          }
          {/* <p className="subscribe-links">
            <a className="button text-button -light-yellow type-text -ch -ss" target="_blank" rel="noopener noreferrer" href="http://eepurl.com/gbLE3z">訂閱最新消息</a>
            <a className="button text-button -light-yellow type-text -ch -ss" target="_blank" rel="noopener noreferrer" href="https://fzhan.us17.list-manage.com/unsubscribe?u=36d91258ac674cf9e4edbaacd&id=216d23cc96">取消最新消息訂閱</a>
          </p> */}
         <div className="subscribe-links">
          <p class="type-text">電話：02-8195-8600</p>
          <p class="type-text">地址：新北市新店區北新路三段200號9樓</p>
        </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
